import { mergeAll } from 'ramda';

import state, { getJobEvaluationState } from './state';
import actions from './guideline-model/actions';
import mutations from './guideline-model/mutations';
import valuationModelActions from './valuation-model/actions';
import valuationModelMutations from './valuation-model/mutations';

const globalMutations = {
	// eslint-disable-next-line no-unused-vars
	CLEAR_STATE(mutationState) {
		// eslint-disable-next-line no-param-reassign
		mutationState = getJobEvaluationState();
	},
};

const globalActions = {
	cleanJobEvaluationState({ commit }) {
		commit('CLEAR_STATE');
	},
};

export default {
	mutations: mergeAll([mutations, valuationModelMutations, globalMutations]),
	actions: mergeAll([actions, valuationModelActions, globalActions]),
	state,
};



// WEBPACK FOOTER //
// ./src/modules/job-evaluation/store/index.js